<template>
  <div class="d-flex flex-column flex-column-fluid" id="kt_content">
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div id="kt_content_container" class="container-xxl">
        <div v-show="isReady" class="card">
          <div class="card-header flex-wrap border-0 pt-6 pb-0">
            <div class="card-title">
              <div class="d-flex align-items-center flex-equal fw-row me-4 order-2" data-bs-toggle="tooltip"
                   data-bs-trigger="hover" >
                <div class="fs-6 fw-bolder text-gray-700 text-nowrap">
                  {{$t('store.output.create.date')}}
                </div>
                <div class="position-relative d-flex align-items-center w-250px">
                  <input class="form-control form-control-transparent fw-bolder pe-5"
                         id="kt_hbd" v-model="formContentOutput.date" required
                         :placeholder="$t('store.entrie.create.date_placeholder')"
                         name="invoice_date" />
                  <span class="svg-icon svg-icon-2 position-absolute ms-4 end-0">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                               viewBox="0 0 24 24" fill="none">
                              <path
                                  d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
                                  fill="currentColor" />
                          </svg>
                      </span>
                </div>
              </div>
            </div>
            <div class="card-toolbar">
              <div class="d-flex flex-center flex-equal fw-row text-nowrap order-1 order-xxl-2 me-4"
                   data-bs-toggle="tooltip" data-bs-trigger="hover" title="Enter invoice number">
                      <span class="fs-2 fw-bolder text-gray-800">{{ $t('store.output.titre') }} :
                      </span>
                <input type="text"
                       class="form-control form-control-transparent fw-bolder fs-3 w-250px"
                       :value="formContentOutput.numero"
                       readonly />
              </div>
              <div class="d-flex align-items-center justify-content-end flex-equal order-3 fw-row"
                   data-bs-toggle="tooltip" data-bs-trigger="hover"
                   title="Specify invoice due date">
                <div class="fs-6 fw-bolder text-gray-700 text-nowrap">{{ $t('shop.shop') }}
                  : {{ shop.name }}</div>
                <div class="position-relative d-flex align-items-center w-150px">
                  <input class="form-control form-control-transparent fw-bolder pe-5" readonly
                         value="" />
                </div>
              </div>
            </div>
          </div>
          <div class="separator separator-dashed"></div>
          <div class="card-body p-12">
            <div class="mb-0">
              <form @submit.prevent="submitForm" >
                <div class="card">
                  <div class="card-body rounded bg-light"
                       v-for="(item, key) in formContentOutput.items" :key="key">
                    <div class="row">
                      <div class="col-sm-10">
                        <label class="form-label fw-bold mb-1">{{ $t('store.destination_label') }}</label>
                        <select :data-key="key" required
                                class="form-select kt_select2 mb-2 col-sm-10"
                                data-control="select2" v-model="item.entityToable_id" name="shop"
                                :data-placeholder="$t('store.shop_placeholder')"
                                data-allow-clear="false">
                          <option></option>
                          <option v-for="entity in entities" :key="entity.id"
                                  :value="entity.id">{{ entity.name }}</option>
                        </select>
                      </div>
                    </div>
                    <hr>
                    <div class="row" v-for="(products, id) in item.products" :key="id">
                      <div class="col-sm-5">
                        <label class="form-label fw-bold mb-1">{{ $t('store.product_label') }}</label>
                        <select :data-item-key="key" :data-product-key="id" required
                                class="mb-6 form-select kt_select2" data-control="select2"
                                v-model="products.product_sale_element_id"
                                name="product_sale_element"
                                :data-placeholder="$t('store.product_placeholder')"
                                data-allow-clear="false">
                          <option></option>
                          <option v-for="product in filterProductSaleElements(key, id)" :key="product.id"
                                  :value="product.id">{{
                            product.name
                            }}
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-2">
                        <label class="form-label fw-bold mb-1">{{ $t('store.stock_available') }}</label>
                        <input type="text" readonly :value="getQuantityById(products.product_sale_element_id)"
                               class="mb-6 form-control" :placeholder="$t('store.stock_available')" />
                      </div>
                      <div class="col-sm-2">
                        <label class="form-label fw-bold mb-1">{{ $t('store.entrie.create.lot') }}</label>
                        <select :data-item-key="key" :data-product-key="id"
                                class="mb-6 form-select kt_select2" data-control="select2"
                                v-model="products.product_lot_id"
                                name="lot"
                                :data-placeholder="$t('store.entrie.create.lot')"
                                data-allow-clear="false">
                          <option v-for="lot in filterProductSaleElementLots(key, id, products.product_sale_element_id)" :key="lot.id" :value="lot.id">
                            {{ lot.lot.name }} ({{ lot.lot.item_number }})
                          </option>
                        </select>
                      </div>
                      <div class="col-sm-2">
                        <label class="form-label fw-bold mb-1">{{ $t('store.qty_to_transfer') }}</label>
                        <input type="text" v-model="products.quantity" min="0"
                               class="mb-6 form-control" name="date" required
                               :placeholder="$t('store.qty_to_transfer')" />
                      </div>
                      <div class="col-sm-1">
                        <label class="form-label fw-bold mb-1 d-block invisible">-</label>
                        <button @click.prevent="dropProductLine(key, id)" type="button"
                                class="btn btn-sm btn-icon text-danger btn-active-color-danger"
                                data-kt-element="remove-item">
                              <span class="svg-icon svg-icon-3">
                                  <svg xmlns="http://www.w3.org/2000/svg" width="24"
                                       height="24" viewBox="0 0 24 24" fill="none">
                                      <path
                                          d="M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z"
                                          fill="currentColor" />
                                      <path opacity="0.5"
                                            d="M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z"
                                            fill="currentColor" />
                                      <path opacity="0.5"
                                            d="M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z"
                                            fill="currentColor" />
                                  </svg>
                              </span>
                        </button>
                      </div>
                      <hr>
                    </div>
                    <div class="row">
                      <div class="col-sm-8"></div>
                      <div class="col-sm-4">
                        <button @click.prevent="addLigneProduct(key)" type="button"
                                class="btn btn-sm btn-light-primary">
                          <i class="fa fa-plus"></i>
                          {{ $t('product.add_product') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mt-5 d-flex justify-content-end">
                    <button type="submit" @click="button ='draft'" class="btn btn-sm btn-light-danger me-2" id="kt_invoice_submit_button"
                            :disabled="isLoading1">
                      <span class="indicator-label" v-if="!isLoading1">{{ $t('button.draft') }}</span>
                      <span class="" v-else>{{ $t('loading') }}
                          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    </button>
                    <button  type="submit" @click="button = 'send'" class="btn btn-sm btn-primary" id="ckt_invoice_submit_button"
                             :disabled="isLoading2">
                      <span class="indicator-label" v-if="!isLoading2">{{ $t('button.send') }}</span>
                      <span class="" v-else>{{ $t('loading') }}
                          <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    </button>
                  </div>
                </div>
              </form>

            </div>
          </div>
        </div>
        <div class="card mb-5 mb-xl-10 loader" v-show="!isReady">
          <Loader text="Loading..." />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import AppSubHeader from "@/views/Settings/Stores/partials/AppSubHeaderStoreOutputCreate.vue";
import Loader from "@/components/Loader.vue";
import { mapActions, mapGetters } from 'vuex'
export default {
  components: {
    AppSubHeader,
    Loader,
  },
  props: {
    shop: {
      type: Object,
      default: {}
    },
    transferCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    let date = new Date().getDate();
    let month = new Date().getMonth() + 1;
    let year = new Date().getFullYear();
    let formattedDate = `${(date < 10) ? '0' + date : date}/${(month < 10) ? '0' + month : month}/${year}`;
    return {
      isLoading1: false,
      isLoading2: false,
      productSaleElement: [],
      supplier: {},
      numberOut: '',
      entrieDetails: {},
      quantity: 0,
      productLot: [],
      porductSaleElementLots: [],
      title: i18n.global.t('store.transfer'),
      breadcrumbs: [
        {
          name: i18n.global.t('breadcrumbs.setting.setting'),
          path: '/admin/settings-index/items'
        },
        {
          name: i18n.global.t('breadcrumbs.store.path'),
          path: '/admin/stores'
        },
        {
          name: i18n.global.t('breadcrumbs.store.output.pathOutput'),
          path: '/admin/settings-index/store/' + this.$route.params.id + '/create/output'
        }
      ],
      formContentOutput: {
        entityFromable_id: this.$route.params.id,
        numero: '',
        type: 'shop',
        date: formattedDate,
        status: 'Draft',
        items: [
          {
            entityToable_id: null,
            type: 'shop',
            products: [
              {
                product_sale_element_id: null,
                quantity: null,
                product_lot_id: null,
                comments: '',
              }
            ],
          }
        ]
      },
      entities: {},
      placeholder: "",
      isReady: false,
      button: 'draft'
    }
  },

  watch: {
    formContentOutputItemsLength: function () {
      this.$nextTick(() => {
        this.initSelect2({
          dateFormat: "d/m/Y",
        })
      })
    },

  },

  async mounted() {
    this.isReady = false
    this.getProductSale()
    await this.loadShops({ status: "active", search: "" })
    this.initProductSaleElementLots()

    this.entities = this.getShops.filter((shop) => {
      return shop.id !== this.$route.params.id
    })

    let prefix = this.shop.transfer_number ?  this.$addYearToPrefixe(this.shop.transfer_number)  : 'TRA/' + this.shop.name.slice(0, 3).toUpperCase() + '/' + (new Date()).getFullYear()
    this.formContentOutput.numero = prefix + '/' + this.$incrementValue(this.transferCount)
    this.placeholder = i18n.global.t('store.shop_placeholder')

    $("#kt_hbd").flatpickr({
      dateFormat: "d/m/Y",
    });

    this.initSelect2()
    this.isReady = true
  },
  computed: {
    ...mapGetters('shop', ['getShops']),

    formContentOutputItemsLength() {
      return JSON.stringify(this.formContentOutput.items)
    },



  },

  methods: {
    ...mapActions('store', ['createOutputShop', 'showShop', 'numberEntryOutput']),
    ...mapActions('shop', ['loadShops', 'showShop', 'getShopProducts']),
    ...mapActions('products', ['getProductSaleElementLot', 'listProductLots']),

    async getProductSale() {
      await this.getShopProducts(this.$route.params.id).then((response) => {
        this.productSaleElement = response.data
      }).catch((err) => {
        window.toastr['error'](err)
      });
    },

    addLigne() {
      this.formContentOutput.items.push(
          {
            entityToable_id: null,
            type: '',
            products: [
              {
                product_sale_element_id: null,
                quantity: null,
                product_lot_id: null,
                comments: '',
              }
            ],
          }
      )

      this.initSelect2()
    },
    getQuantityById(productId) {
      for (const product of this.productSaleElement) {
        if (product.id === productId) {
          return product.quantity;
        }
      }
      return 0;
    },
    addLigneProduct(key) {
      this.formContentOutput.items[key].products.push(
          {
            product_sale_element_id: null,
            type: '',
            quantity: null,
            product_lot_id: null,
            comments: '',
          }
      )
      this.initSelect2()
    },
    async initProductSaleElementLots(){
      let response = await this.listProductLots()
      this.porductSaleElementLots = response.data
    },
    formatProduct(items) {
      return (items.attribut.length > 0) ? ' (' + items.attribut + ')' : '';
    },
    sortByKey(array, key) {
      return array.sort(function(a, b) {
        var x = a[key].toLowerCase();
        var y = b[key].toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },
    filterProductSaleElements(key, id) {
      let productBeforeKey = [];

      for (let i = 0; i < id; i++) {
        const productSale = this.formContentOutput.items[key].products[i];
        if (this.filterProductSaleElementLots(key, i, productSale.product_sale_element_id).length === 0) {
          productBeforeKey.push(productSale.product_sale_element_id);
        }
      }

      let product_lists = this.productSaleElement.filter(product => !productBeforeKey.includes(product.id));
      return this.sortByKey(product_lists, "name");
    },
    filterProductSaleElementLots(key, id, product_sale_element_id) {
      if(product_sale_element_id != null){
        let newProductLots = this.porductSaleElementLots.filter(lot => lot.product_sale_element_id === product_sale_element_id);
        let productBeforeKey = this.formContentOutput.items[key].products
            .filter((data, i) => i < id)
            .map(data => data.product_lot_id);

        return newProductLots.filter(lot => !productBeforeKey.includes(lot.id));
      }
      return []
    },
    async createOutput(bool) {

      if(bool){

        this.formContentOutput.status = "Draft"
      }
      let response = {}
      bool ? this.isLoading1 = true : this.isLoading2 = true


      try {

        response = await this.createOutputShop(this.formContentOutput)
        window.toastr['success'](i18n.global.t('notification.store.output_create'))
        this.$router.push('/admin/shops/' + this.$route.params.id + '/view/moves')
      } catch (e) {
        bool ? this.isLoading1 = false : this.isLoading2 = false
        if (response && response.data) {
          window.toastr['error'](response.data.error)
        }
      }
    },
    sendOutput() {
      Swal.fire({
        title: i18n.global.t('store.swal_title_send_output'),
        text: i18n.global.t('store.swal_text'),
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: i18n.global.t('store.output.yes'),
        cancelButtonText: i18n.global.t('store.output.no'),
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.formContentOutput.status = "Send"
          await this.createOutput(false)
        }
      });
    },

    dropShopLigne(key) {
      if (this.formContentOutput.items.length > 1) {
        this.formContentOutput.items.splice(key, 1)
      }
    },

    dropProductLine(key, id) {
      if (this.formContentOutput.items[key].products.length > 1) {
        this.formContentOutput.items[key].products.splice(id, 1)
      }
    },

    initSelect2() {
      $(".kt_select2").select2()
      $(".kt_select2").select2().select2()

      $(".kt_select2").change((e) => {
        switch (e.target.name) {
          case 'shop':
            this.formContentOutput.items[e.target.getAttribute('data-key')].entityToable_id = e.target.value
            break;
          case 'product_sale_element':
            let data = {
              entityFromable_id: this.$route.params.id,
              productSaleElement_id: e.target.value
            }
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_sale_element_id = e.target.value
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].quantity = null
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_lot_id = null
            break;
          case 'lot':
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].product_lot_id = e.target.value
            this.formContentOutput.items[e.target.getAttribute('data-item-key')].products[e.target.getAttribute('data-product-key')].quantity = null
            break;
          default:
            break;
        }
      });

      $(".kt_select2").select2({
        placeholder: this.placeholder
      });
    },

    submitForm(){
      if(this.button == 'draft'){
        return this.createOutput(true)
      }else {
        return this.sendOutput()
      }
    }
  }
}
</script>

<style scoped>
.light-danger {
  color: #f1416c;
  border-color: #fff5f8;
  background-color: #fff5f8;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}

.light-primary {
  color: #0b3d87;
  border-color: #f1faff;
  background-color: #f1faff;
  font-size: .925rem;
  border-radius: 0.325rem;
  padding: 5px 10px;
}
@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>